export const formatDateEnToPt = (date: string): string => {
  const dateParts = date.split('-');
  if (dateParts.length !== 3) {
    return date;
  }
  return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
};

export const formatToDDMMYYYY = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
